export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[960px] mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-6 md:p-10">
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
              <div className="w-full md:w-[380px] flex-shrink-0">
                <div className="w-full aspect-[16/10] rounded-xl overflow-hidden bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20Korean%20webtoon%20comic%20reading%20interface%20on%20a%20clean%20desk%20with%20warm%20ambient%20lighting%2C%20modern%20minimal%20setup%2C%20soft%20coral%20and%20cream%20tones%2C%20editorial%20product%20photography&width=1000&height=625&seq=app-mobile-kr-comics&orientation=landscape"
                    alt="韩国漫画网移动端阅读入口"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                  随时随地 · 沉浸追漫
                </h2>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                  韩国漫画网完美适配手机端浏览，支持下拉式阅读模式，无论在通勤路上还是睡前时光，都能享受流畅的韩漫阅读体验。收藏你喜爱的漫画，不错过每一次更新。
                </p>
                <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
                  <a
                    href="#app"
                    onClick={(e) => e.preventDefault()}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 font-medium text-sm rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-smartphone-line"></i>
                    手机端访问
                  </a>
                  <a
                    href="#features"
                    onClick={(e) => { e.preventDefault(); const el = document.querySelector('#features'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
                    className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-background-200/50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解更多功能
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}